// React core & router
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from '../withRouter'; // HOC สำหรับจัดการ routing

// HTTP client
import axios from 'axios';

// sweetalert2
import Swal from 'sweetalert2'

// Bootstrap components
import {
    Breadcrumb, Row, Col, Card, Image
} from 'react-bootstrap';

// Font สำหรับ export DOCX
import htmlDocx from 'html-docx-js/dist/html-docx';
import TH_Sarabun_PSK from '../../fonts/TH_Sarabun_PSK/THSarabun.ttf'; // ฟอนต์สำหรับ DOCX

// RSuite UI components
import {
    Tabs, ButtonToolbar, IconButton,
    Checkbox, Whisper, Tooltip, Loader
} from 'rsuite';

class DetailPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            header: null,
            content: null,
            educationHistory: [],
            internshipHistory: [],
            activityHistory: [],
            careerHistory: []
        };
    }

    async componentDidMount() {
        try {
            // ดึงข้อมูล user จาก localStorage
            const loggedData = localStorage.getItem('logged');
            const user = loggedData ? JSON.parse(loggedData)?.user : null;

            if (!user || !user.token || !user.user?.id) {
                window.location.href = '/login';
                return;
            }

            // ตั้งค่า auth header
            const authHeader = {
                headers: {
                    Authorization: `Bearer ${user.token}`
                }
            };

            // บันทึก header ลง state
            await this.promisedSetState({ authHeader });

            // เรียก API ดึง application ล่าสุดตาม user id
            const response = await axios.get(
                `${process.env.REACT_APP_API}/application/latest/${user.user.id}`,
                authHeader
            );

            const applicationData = response.data;

            // Render Header และ Content
            await this.onRenderHeader({ mode: 'read', data: applicationData });
            await this.onRenderContent({ mode: 'read', report: 'short', data: applicationData });

        } catch (error) {
            if (error.response?.status === 401) {
                window.location.href = '/login';
            } else {
                // จัดการ error อื่น ๆ ตามปกติ
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
        }
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    onRenderHeader = async ({ mode, data }) => {
        if (mode === 'read') {
            await this.promisedSetState({
                header: <><Row className='mt-3'>
                    <Col>
                        <Breadcrumb size='lg' >
                            <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                            <Breadcrumb.Item>ประวัติส่วนตัว</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                    <Row className='mb-3'>
                        <Col md={4}>
                        </Col>

                        <Col md={4} className="d-flex justify-content-center">
                            <Tabs defaultActiveKey="short" appearance="pills" onSelect={e => this.onRenderContent({ mode: 'read', report: e, data })}>
                                <Tabs.Tab eventKey="short" title="ประวัติย่อ" />
                                <Tabs.Tab eventKey="long" title="ประวัติแบบละเอียด" />
                            </Tabs>
                        </Col>

                        <Col md={4} className="d-flex justify-content-end">
                            <ButtonToolbar>
                                <Whisper
                                    followCursor
                                    speaker={<Tooltip>Print</Tooltip>}
                                >
                                    <IconButton
                                        icon={<i className="bi bi-printer"></i>}
                                        style={{ backgroundColor: '#adadad', color: 'white' }}
                                        onClick={this.handlePrint}
                                    />
                                </Whisper>
                                <Whisper
                                    followCursor
                                    speaker={<Tooltip>Document</Tooltip>}
                                >
                                    <IconButton
                                        color="blue"
                                        appearance="primary"
                                        icon={<i className="bi bi-file-earmark-word"></i>}
                                        onClick={this.handleExportToDocx}
                                    />
                                </Whisper>
                            </ButtonToolbar>
                        </Col>
                    </Row></>
            })
        }
    }

    formatDateOfBirth(dateOfBirth) {
        const date = new Date(dateOfBirth);

        // Thai locale options for formatting
        const options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        };

        // Format the date using Thai locale
        const formattedDate = new Intl.DateTimeFormat('th-TH', options).format(date);

        // Convert the year to Buddhist Era (BE), which is 543 years ahead of the Gregorian calendar
        const buddhistYear = date.getFullYear() + 543;

        // Replace the Gregorian year with the Buddhist Era year in the formatted date
        const finalDate = formattedDate.replace(date.getFullYear(), buddhistYear);

        return finalDate;
    }

    calculateAge = (date_of_birth) => {
        const birthDate = new Date(date_of_birth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();

        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    formatBaht(income) {
        // Convert the number to a formatted string with commas and two decimal places
        return income.toLocaleString('th-TH', {
            minimumFractionDigits: 2,  // Ensures two decimal places
            maximumFractionDigits: 2   // Limits to two decimal places
        });
    }

    onRenderContent = async ({ mode, report, data }) => {
        if (mode === 'read' && report === 'short') {

            await this.promisedSetState({ loading: true })

            const statusMap = {
                'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ': data.parent_status_1,
                'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ': data.parent_status_2,
                'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ': data.parent_status_3,
                'อื่นๆ โปรดระบุ': data.parent_status_4
            };

            const extraText = statusMap[data.parent_status] || '';

            const parentStatusText = extraText
                ? `${data.parent_status} ${extraText}`
                : data.parent_status;

            await this.promisedSetState({
                content: <div>
                    <Row>
                        <Col>
                            <Card
                                id="printable"
                                border="light"
                                className="shadow-sm"
                                style={{
                                    paddingLeft: "1.5em",
                                    paddingTop: "1em",
                                    paddingRight: "1em",
                                    paddingBottom: "1em",
                                    fontSize: '16pt',
                                    lineHeight: '1.2'
                                }}
                            >
                                {/* Row for "ลำดับที่......" */}
                                <div style={{ marginTop: '1.5em', textAlign: "center" }}>
                                    <Image
                                        src={`${process.env.REACT_APP_UPLOAD}/${data.path}`}
                                        rounded
                                        style={{ width: "2.5cm", height: "3.5cm" }}
                                    />
                                </div>

                                <div style={{ marginTop: '1em' }}>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}><b>สิทธิ์ในการสมัคร</b></span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights4}
                                            readOnly
                                        >
                                            บุตรพนักงาน
                                        </Checkbox>
                                    </span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights1}
                                            readOnly
                                        >
                                            พื้นที่โครงการพัฒนาดอยตุงฯ
                                        </Checkbox>
                                    </span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights2}
                                            readOnly
                                        >
                                            พื้นที่ขยายผลในมูลนิธิฯ
                                        </Checkbox>
                                    </span>
                                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                                        <Checkbox
                                            checked={data.rights3}
                                            readOnly
                                        >
                                            โรงเรียนบ้านห้วยไร่สามัคคี
                                        </Checkbox>
                                    </span>
                                </div>

                                <div><span><b><u>ข้อมูลทั่วไป</u></b></span></div>
                                <div>
                                    <span>ชื่อ-สกุล: </span><span>{`${data.first_name} ${data.last_name}`}</span>
                                    <span style={{ paddingLeft: '1em' }}>ชื่อเล่น: </span><span>{data.nickname}</span>
                                </div>
                                <div>
                                    <span>วัน/เดือน/ปี เกิด: </span><span>{this.formatDateOfBirth(data.date_of_birth)}</span>
                                    <span style={{ paddingLeft: '1em' }}>อายุ: </span><span>{this.calculateAge(data.date_of_birth)} ปี</span>
                                </div>
                                <div><span>เบอร์โทร: </span><span>{data.phone}</span></div>
                                <div><span>ที่อยู่: </span><span> {data.reg_province_id === 1 ? (
                                    <>
                                        บ้านเลขที่ {data.reg_house_number} หมู่ที่ {data.reg_village_no} หมู่บ้าน
                                        {data.reg_village === "other" ? data.reg_village_name : data.reg_village}{" "}
                                        {data.reg_tambon} {data.reg_amphur} {data.reg_province}
                                    </>
                                ) : (
                                    <>
                                        บ้านเลขที่ {data.reg_house_number} หมู่ที่ {data.reg_village_no} หมู่บ้าน
                                        {data.reg_village === "other" ? data.reg_village_name : data.reg_village} ต.
                                        {data.reg_tambon} อ.{data.reg_amphur} จ.{data.reg_province}
                                    </>
                                )}
                                </span></div>
                                <div><span>เลขบัตรประชาชน: </span><span>{data.id_card_number}</span></div>
                                <div>
                                    <span>การศึกษาเดิม : </span><span>{data.edu_level}</span>
                                    <span style={{ paddingLeft: '1em' }}>โรงเรียน : </span><span>{data.curr_institution}</span>
                                    <span style={{ paddingLeft: '1em' }}>สายการเรียน : </span><span>{data.curr_field}</span>
                                </div>
                                <div><span>ผลการเรียน: </span><span>{data.grades}</span></div>

                                <div style={{ marginTop: '1em' }}><span><b><u>ข้อมูลการศึกษาต่อ</u></b></span></div>
                                <div><span>สถานศึกษา: </span><span>{data.next_institution}</span></div>
                                <div><span>สาขาที่ศึกษาต่อ: </span><span>{data.next_field}</span></div>

                                <div style={{ marginTop: '1em' }}><span><b><u>ข้อมูลการพิจารณาทุน</u></b></span></div>

                                <div><span><b>ส่วนที่ 1 ครอบครัวและรายได้</b></span></div>
                                <div style={{ marginLeft: '2em' }}>
                                    <span>สภาพครอบครัว: </span>
                                    <span>{parentStatusText}</span>
                                </div>
                                <div style={{ marginLeft: '4em' }}>
                                    <span>ชื่อบิดา: </span><span>{data.father_full_name}</span>
                                    <span style={{ marginLeft: '1em' }}>อาชีพ: </span><span>{data.father_occupation}</span>
                                </div>
                                <div style={{ marginLeft: '4em' }}>
                                    <span>ชื่อมารดา: </span><span>{data.mother_full_name}</span>
                                    <span style={{ marginLeft: '1em' }}>อาชีพ: </span><span>{data.mother_occupation}</span>
                                </div>
                                <div style={{ marginLeft: '4em' }}><span>จำนวนพี่น้อง: </span><span>{data.total_siblings} คน</span></div>
                                <div style={{ marginLeft: '2em' }}><span>จำนวนรายได้รวม: </span><span>{this.formatBaht(data.family_income_per_year)} บาท ต่อปี</span></div>
                                <div style={{ marginLeft: '2em' }}><span>ที่อยู่อาศัยในพื้นที่: </span><span>{data.family_residence_rai} ไร่ {data.family_residence_ngan} งาน {data.family_residence_wah} ตารางวา</span></div>
                                <div style={{ marginLeft: '2em' }}><span>ที่ทำกินในพื้นที่: </span><span>{data.family_work_rai} ไร่ {data.family_work_ngan} งาน {data.family_work_wah} ตารางวา</span></div>
                                <div style={{ marginLeft: '2em' }}><span>ที่อยู่อาศัยนอกพื้นที่: </span><span>- ไร่ - งาน - ตารางวา</span></div>
                                <div style={{ marginLeft: '2em' }}><span>ที่ทำกินนอกพื้นที่: </span><span>- ไร่ - งาน - ตารางวา</span></div>

                                <div><span><b>ส่วนที่ 2 กิจกรรมที่เข้าร่วมระหว่างเรียน</b></span></div>
                                <div style={{ marginLeft: '2em' }}><span><b>กิจกรรมที่เคยเข้าร่วมกับมูลนิธิแม่ฟ้าหลวงฯ:</b> </span><span>{data.doitung_activities}</span></div>
                                <div style={{ marginLeft: '2em' }}><span><b>กิจกรรมที่เข้าร่วมกับโรงเรียน:</b> </span><span>{data.school_activities}</span></div>
                                <div style={{ marginLeft: '2em' }}><span><b>กิจกรรมอื่นๆ:</b> </span><span>{data.other_activities}</span></div>

                            </Card>
                        </Col>
                    </Row>
                    <br />
                </div>
            })

            await this.promisedSetState({ loading: false })

        } else if (mode === 'read' && report === 'long') {

            await this.promisedSetState({ loading: true })

            // monthNamesThai และ formatDateThaiShort ไว้ข้างบนของไฟล์ หรือใน scope เดียวกันเลย
            const monthNamesThai = [
                'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
                'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
            ];

            function formatDateThaiShort(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                if (isNaN(date)) return '';

                const day = date.getDate();
                const month = monthNamesThai[date.getMonth()];
                const year = (date.getFullYear() + 543) % 100; // ปี พ.ศ. สองหลัก

                return `${day} ${month} ${year}`;
            }

            // ในส่วนของ async function ที่โหลดข้อมูล เช่น componentDidMount หรือ function อื่น
            try {
                // ดึงข้อมูลการศึกษา
                const educationRes = await axios.get(
                    `${process.env.REACT_APP_API}/education/applicant/${data.applicant_id}`,
                    this.state.authHeader
                );
                const educationApiData = educationRes.data;

                await this.promisedSetState({
                    educationHistory: (Array.isArray(educationApiData) ? educationApiData : [educationApiData]).map(item => ({
                        year: item.start_year ? item.start_year.toString() : '',
                        level: item.year_level || '',
                        institution: item.school_name || '',
                        major: item.study_field || '',
                        gpax: item.gpax ? item.gpax.toString() : null
                    }))
                });

                // ดึงข้อมูลฝึกงาน
                const internRes = await axios.get(
                    `${process.env.REACT_APP_API}/internship/applicant/${data.applicant_id}`,
                    this.state.authHeader
                );
                const internshipApiData = internRes.data;

                const internshipHistory = (Array.isArray(internshipApiData) ? internshipApiData : [internshipApiData]).map(item => ({
                    id: item.id,
                    internStartDate: formatDateThaiShort(item.intern_start_date) || '',
                    internEndDate: formatDateThaiShort(item.intern_end_date) || '',
                    position: item.intern_position || '',
                    company: item.intern_company || ''
                }));

                const activityRes = await axios.post(
                    `${process.env.REACT_APP_API}/activity/applicant`,
                    {
                        applicants_id: data.applicant_id,
                        search_type: '',
                        search_date: '',
                        search_text: '',
                    },
                    this.state.authHeader
                );

                const activityApiData = activityRes.data;

                // ฟังก์ชันแปลงวันที่เป็นรูปแบบไทยแบบย่อ (วันที่ เดือน ปี พ.ศ. สองหลัก)
                function formatDateThaiLong(dateString) {
                    if (!dateString) return '';
                    const date = new Date(dateString);
                    if (isNaN(date)) return '';

                    const day = date.getDate();
                    const monthNamesThai = [
                        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                    ];
                    const month = monthNamesThai[date.getMonth()];
                    const fullYear = date.getFullYear() + 543;
                    const year = fullYear % 100; // 2 ตัวท้ายปี

                    return { day, month, year };
                }

                function formatActDate(startDateStr, endDateStr) {
                    const start = formatDateThaiLong(startDateStr);
                    const end = formatDateThaiLong(endDateStr);

                    if (!start || !end) return '';

                    if (start.day === end.day && start.month === end.month && start.year === end.year) {
                        return `${start.day} ${start.month} ${start.year}`;
                    }

                    if (start.year === end.year && start.month === end.month) {
                        return `${start.day} - ${end.day} ${start.month} ${start.year}`;
                    }

                    if (start.year === end.year && start.month !== end.month) {
                        return `${start.day} ${start.month} - ${end.day} ${end.month} ${start.year}`;
                    }

                    return `${start.day} ${start.month} ${start.year} - ${end.day} ${end.month} ${end.year}`;
                }

                // แปลงข้อมูล API ให้เป็นข้อมูลที่แสดงผลได้ง่าย
                const activityHistory = (Array.isArray(activityApiData) ? activityApiData : [activityApiData]).map(item => ({
                    id: item.id,
                    actType: item.act_type || "",
                    actName: item.act_name || "",
                    actPlace: item.act_place || "",
                    actDate: formatActDate(item.act_start, item.act_end) || ""
                }));

                const careerRes = await axios.get(
                    `${process.env.REACT_APP_API}/career/applicant/${data.applicant_id}`,
                    this.state.authHeader
                );

                const careerApiData = careerRes.data;

                // ฟังก์ชันแปลงวันที่เป็น "1 กันยายน 66"
                function formatDateThaiShort(dateString) {
                    if (!dateString) return '';
                    const date = new Date(dateString);
                    if (isNaN(date)) return '';

                    const day = date.getDate();
                    const month = monthNamesThai[date.getMonth()];
                    const year = (date.getFullYear() + 543) % 100;

                    return `${day} ${month} ${year}`;
                }

                // แปลงข้อมูล API ให้เป็นข้อมูลที่แสดงผลได้ง่าย
                const careerHistory = (Array.isArray(careerApiData) ? careerApiData : [careerApiData]).map(item => ({
                    id: item.id,
                    start_date: formatDateThaiShort(item.start_date) || "-",
                    end_date: formatDateThaiShort(item.end_date) || "-",
                    department: item.department || "-",
                    company_name: item.company_name || "-",
                }));

                await this.promisedSetState({ internshipHistory, activityHistory, careerHistory });

            } catch (error) {
                console.error('Error loading applicant data:', error);
                await this.promisedSetState({
                    educationHistory: [],
                    internshipHistory: []
                });
            }

            // Styles
            const cellStyle = {
                border: '0.5px solid #ccc',
                padding: '4px',
                fontWeight: 'normal',
                textAlign: 'center'
            };

            const cellStyleLeft = {
                ...cellStyle,
                textAlign: 'left'
            };

            const headerStyle = {
                ...cellStyle,
                backgroundColor: '#f0f0f0',
                fontWeight: 'bold'
            };

            const statusMap = {
                'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ': data.parent_status_1,
                'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ': data.parent_status_2,
                'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ': data.parent_status_3,
                'อื่นๆ โปรดระบุ': data.parent_status_4
            };

            const extraText = statusMap[data.parent_status] || '';

            const parentStatusText = extraText
                ? `${data.parent_status} ${extraText}`
                : data.parent_status;

            await this.promisedSetState({
                content: <div><Row>
                    <Col>
                        <Card id="printable" border="light"
                            className='shadow-sm'
                            style={{
                                paddingLeft: "1.5em",
                                paddingTop: "1em",
                                paddingRight: "1em",
                                paddingBottom: "1em",
                                fontSize: '16pt',
                                lineHeight: '1.2'
                            }}>

                            <div>
                                <Image
                                    src={`${process.env.REACT_APP_UPLOAD}/${data.path}`}
                                    rounded
                                    style={{ width: '2.5cm', height: '3.5cm' }}
                                />
                            </div>

                            <div style={{ marginTop: '1em' }}><span><b>ข้อมูลทั่วไป</b></span></div>

                            <div style={{ marginBottom: '0.1em' }}><span>เลขบัตรประชาชน: </span><span>{data.id_card_number}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อ-สกุล: </span><span>{`${data.first_name} ${data.last_name}`}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อเล่น: </span><span>{data.nickname}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ชนเผ่า: </span><span>{data.ethnicity}</span></div>
                            <div style={{ marginBottom: '0.1em' }}>
                                <span>วัน/เดือน/ปี เกิด: </span><span>{this.formatDateOfBirth(data.date_of_birth)}</span>
                                <span style={{ paddingLeft: '1em' }}>อายุ: </span><span>{this.calculateAge(data.date_of_birth)} ปี</span>
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่ตามทะเบียนบ้าน: </span><span>{
                                data.reg_province_id === 1
                                    ? (
                                        <>
                                            บ้านเลขที่ {data.reg_house_number}{' '}
                                            หมู่ที่ {data.reg_village_no}{' '}
                                            หมู่บ้าน {data.reg_village === 'other' ? data.reg_village_name : data.reg_village}{' '}
                                            {data.reg_tambon}{' '}
                                            {data.reg_amphur}{' '}
                                            {data.reg_province}{' '}
                                        </>
                                    )
                                    : (
                                        <>
                                            บ้านเลขที่ {data.reg_house_number}{' '}
                                            หมู่ที่ {data.reg_village_no}{' '}
                                            หมู่บ้าน {data.reg_village === 'other' ? data.reg_village_name : data.reg_village}{' '}
                                            ต.{data.reg_tambon}{' '}
                                            อ.{data.reg_amphur}{' '}
                                            จ.{data.reg_province}{' '}
                                        </>
                                    )
                            }</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่จริงในปัจจุบัน: </span><span>{data.is_reg_address === 'yes' ? 'ใช่' :
                                (
                                    <>
                                        บ้านเลขที่ {data.temp_house_number}{' '}
                                        หมู่ที่ {data.temp_village_no}{' '}
                                        หมู่บ้าน {data.temp_village === 'other' ? data.temp_village_name : data.temp_village}{' '}
                                        ต.{data.temp_tambon}{' '}
                                        อ.{data.temp_amphur}{' '}
                                        จ.{data.temp_province}{' '}
                                    </>
                                )}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>โทรศัพท์ติดต่อส่วนตัวของผู้สมัครขอรับทุน: </span><span>{data.phone}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่ (บ้าน/ที่อยู่อาศัย) ของครอบครัว: </span>
                                {data.is_family_residence === 'yes' ? <span>มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว จำนวน {data.family_residence_rai} ไร่ {data.family_residence_ngan} งาน {data.family_residence_wah} ตารางวา</span>
                                    : <span>ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว</span>}
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่ทำกินของครอบครัว: </span>
                                {data.is_family_work === 'yes' ? <span>มีที่ทำกินเป็นของครอบครัว จำนวน {data.family_work_rai} ไร่ {data.family_work_ngan} งาน {data.family_work_wah} ตารางวา</span>
                                    : <span>ไม่มีที่ทำกินของครอบครัว</span>}
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่อยู่ (บ้าน/ที่อยู่อาศัย) นอกพื้นที่: </span>
                                {data.is_none_residence === 'yes' ? <span>มีบ้าน/ที่อยู่อาศัยนอกพื้นที่ จำนวน {data.none_residence_rai} ไร่ {data.none_residence_ngan} งาน {data.none_residence_wah} ตารางวา</span>
                                    : <span>ไม่มีบ้าน/ที่อยู่อาศัยนอกพื้นที่</span>}
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ที่ทำกินนอกพื้นที่: </span>
                                {data.is_none_work === 'yes' ? <span>มีที่ทำกินเป็นนอกพื้นที่ จำนวน {data.none_work_rai} ไร่ {data.none_work_ngan} งาน {data.none_work_wah} ตารางวา</span>
                                    : <span>ไม่มีที่ทำกินนอกพื้นที่</span>}
                            </div>

                            <div style={{ marginTop: '1em' }}>
                                <div style={{ marginBottom: '0.3em', fontWeight: 'bold' }}>
                                    <i className="bi bi-book-half"></i>{' '}ข้อมูลการศึกษา
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>ระดับการศึกษาที่ศึกษาอยู่: </span>
                                    <span>{data.edu_level}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สถานศึกษา ณ ปัจจุบัน: </span>
                                    <span>{data.curr_institution}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สาย/สาขาวิชา: </span>
                                    <span>{data.curr_field}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>ผลการเรียนเฉลี่ยรวม (5 ภาคเรียนหรือเทอมล่าสุด): </span>
                                    <span>{data.grades}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สถานศึกษาที่จะเรียนต่อ: </span>
                                    <span>{data.next_institution}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em' }}>
                                    <span>สาย/สาขาที่จะเรียนต่อ: </span>
                                    <span>{data.next_field}</span>
                                </div>

                                <div style={{ marginBottom: '0.5em' }}>
                                    <span>สถานะการสมัครเรียนในมหาวิทยาลัย: </span>
                                    <span>{data.app_status}</span>
                                </div>

                                <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                    <span>ตารางประวัติการศึกษา</span>
                                </div>

                                <div style={{
                                    overflow: 'hidden',
                                    outline: '0.5px solid #ccc',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                    marginBottom: '0.5em'
                                }}>
                                    <table style={{
                                        width: '100%',
                                        borderCollapse: 'collapse'
                                    }}>
                                        <thead>
                                            <tr>
                                                <td style={headerStyle}>ปีการศึกษา</td>
                                                <td style={headerStyle}>ระดับการศึกษา</td>
                                                <td style={headerStyle}>ชื่อโรงเรียน/สถาบัน</td>
                                                <td style={headerStyle}>สาย/สาขาวิชาที่เรียน</td>
                                                <td style={headerStyle}>GPAX</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.educationHistory.length > 0 ? (
                                                this.state.educationHistory.map((item, index) => (
                                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                        <td style={cellStyle}>{item.year}</td>
                                                        <td style={cellStyle}>{item.level}</td>
                                                        <td style={cellStyleLeft}>{item.institution}</td>
                                                        <td style={cellStyleLeft}>{item.major}</td>
                                                        <td style={cellStyle}>{item.gpax}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                        ไม่มีข้อมูลประวัติการศึกษา
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>

                                <div style={{ marginTop: '1em' }}>
                                    <div style={{ marginBottom: '0.3em', fontWeight: 'bold' }}>
                                        <i className="bi bi-suitcase-lg-fill"></i>{' '}ข้อมูลการทำงาน
                                    </div>

                                    <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                        <span>ตารางประวัติการฝึกงาน</span>
                                    </div>

                                    <div style={{
                                        overflow: 'hidden',
                                        outline: '0.5px solid #ccc',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                        marginBottom: '0.5em',
                                    }}>
                                        <table style={{
                                            width: '100%',
                                            borderCollapse: 'collapse'
                                        }}>
                                            <thead>
                                                <tr>
                                                    <td style={headerStyle}>วันที่เริ่มงาน</td>
                                                    <td style={headerStyle}>วันที่สิ้นสุด</td>
                                                    <td style={headerStyle}>ตำแหน่ง</td>
                                                    <td style={headerStyle}>ชื่อบริษัทหรือหน่วยงาน</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.careerHistory && this.state.careerHistory.length > 0 ? (
                                                    this.state.careerHistory.map((item, index) => (
                                                        <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                            <td style={cellStyle}>{item.start_date}</td>
                                                            <td style={cellStyle}>{item.end_date}</td>
                                                            <td style={cellStyleLeft}>{item.department}</td>
                                                            <td style={cellStyleLeft}>{item.company_name}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                            ไม่มีข้อมูลประวัติการฝึกงาน
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                        <span>ตารางประวัติการทำงาน</span>
                                    </div>

                                    <div style={{
                                        overflow: 'hidden',
                                        outline: '0.5px solid #ccc',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
                                    }}>
                                        <table style={{
                                            width: '100%',
                                            borderCollapse: 'collapse'
                                        }}>
                                            <thead>
                                                <tr>
                                                    <td style={headerStyle}>วันที่เริ่มงาน</td>
                                                    <td style={headerStyle}>วันที่สิ้นสุด</td>
                                                    <td style={headerStyle}>ตำแหน่ง</td>
                                                    <td style={headerStyle}>ชื่อบริษัทหรือหน่วยงาน</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.internshipHistory && this.state.internshipHistory.length > 0 ? (
                                                    this.state.internshipHistory.map((item, index) => (
                                                        <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                            <td style={cellStyle}>{item.internStartDate}</td>
                                                            <td style={cellStyle}>{item.internEndDate}</td>
                                                            <td style={cellStyleLeft}>{item.position}</td>
                                                            <td style={cellStyleLeft}>{item.company}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                            ไม่มีข้อมูลประวัติการทำงาน
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '1em' }}><span><b><i className="bi bi-people-fill"></i> ข้อมูลครอบครัว</b></span></div>

                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อ - สกุล บิดา (ผู้ให้กำเนิด): </span><span>{data.father_full_name}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อายุบิดา: </span><span>{data.father_age} ปี</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อาชีพของบิดา: </span><span>{data.father_occupation}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>สถานที่ทำงานของบิดา: </span><span>{data.father_workplace}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>หมายเลขโทรศัพท์ของบิดา: </span><span>{data.father_phone}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ชื่อ-สกุล มารดา (ผู้ให้กำเนิด): </span><span>{data.mother_full_name}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อายุมารดา: </span><span>{data.mother_age} ปี</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>อาชีพของมารดา: </span><span>{data.mother_occupation}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>สถานที่ทำงานของมารดา: </span><span>{data.mother_workplace}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>หมายเลขโทรศัพท์ของมารดา: </span><span>{data.mother_phone}</span></div>
                            <div style={{ marginBottom: '0.1em' }}>
                                <span>สถานะของบิดา มารดา: </span>
                                <span>{parentStatusText}</span>
                            </div>
                            <div style={{ marginBottom: '0.1em' }}><span>ผู้ปกครองที่สามารถติดต่อได้: {data.contactable} ความเกี่ยวข้องกับผู้สมัคร: {data.relationship_to_applicant}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องร่วมบิดามารดา: (ไม่รวมผู้สมัคร) {data.total_siblings} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องที่ทำงานแล้ว: {data.working_siblings} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องที่ว่างงาน: {data.unemployed_siblings} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>จำนวนพี่น้องที่ยังไม่ถึงวัยเรียน: {data.siblings_not_of_age} คน</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>รายได้รวมต่อปีของครอบครัว (รวมรายได้ของบิดา/มารดา/พี่น้องที่ทำงานแล้ว): {this.formatBaht(data.family_income_per_year)} บาท/ปี</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>ผู้ที่สนับสนุนค่าใช้จ่ายในชีวิตประจำวัน/ค่าใช้จ่ายในการเรียนของผู้สมัคร</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span style={{ paddingLeft: '1em' }}>ชื่อ-สกุล: {data.provider_full_name}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span style={{ paddingLeft: '1em' }}>ความเกี่ยวข้องกับผู้สมัคร: {data.provider_relationship}</span></div>

                            <div style={{ marginTop: '1em' }}><span><b><i className="bi bi-palette-fill"></i> ข้อมูลด้านการเข้าร่วมกิจกรรม</b></span></div>

                            <div style={{ marginBottom: '0.1em' }}><span>กิจกรรมที่เคยเข้าร่วมของมูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์/โครงการพัฒนาดอยตุงฯ: {data.doitung_activities}</span></div>
                            <div style={{ marginBottom: '0.1em' }}><span>กิจกรรมที่เคยเข้าร่วมของโรงเรียน: {data.school_activities}</span></div>
                            <div style={{ marginBottom: '0.5em' }}><span>กิจกรรมที่อื่นๆ ที่เคยเข้าร่วม: {data.other_activities}</span></div>

                            <div style={{ marginBottom: '0.1em', fontWeight: 'bold', color: 'rgba(0,0,0,0.6)' }}>
                                <span>ตารางข้อมูลประวัติการเข้าร่วมกิจกรรมระหว่างการศึกษา</span>
                            </div>

                            <div style={{
                                overflow: 'hidden',
                                outline: '0.5px solid #ccc',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
                            }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse'
                                }}>
                                    <thead>
                                        <tr>
                                            <td style={headerStyle}>วันที่กิจกรรม</td>
                                            <td style={headerStyle}>ประเภท</td>
                                            <td style={headerStyle}>ชื่อกิจกรรม</td>
                                            <td style={headerStyle}>สถานที่</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.activityHistory && this.state.activityHistory.length > 0 ? (
                                            this.state.activityHistory.map((item, index) => (
                                                <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff' }}>
                                                    <td style={cellStyle}>{item.actDate}</td>
                                                    <td style={cellStyle}>{item.actType}</td>
                                                    <td style={cellStyleLeft}>{item.actName}</td>
                                                    <td style={cellStyleLeft}>{item.actPlace}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4} style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                                                    ไม่มีข้อมูลประวัติการเข้าร่วมกิจกรรม
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div style={{ marginTop: '1em' }}><span><b>ข้อมูลที่กรอกเพิ่มเติมเฉพาะตามสิทธิ์</b></span></div>

                            {data.rights1 && (<><div><span>สิทธิ์ที่ 1 </span><span>เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการพัฒนาดอยตุงฯ</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>- เลข คพต.พ ของผู้สมัคร: </span><span>{data.applicant_proj_no}</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>- เลข คพต.พ ของบิดา: </span><span>{data.father_proj_no}</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>- เลข คพต.พ ของมารดา: </span><span>{data.mother_proj_no}</span></div></>)}
                            {data.rights2 && (<><div><span>สิทธิ์ที่ 2 </span><span>เป็นเยาวชนที่อาศัยอยู่ในพื้นที่โครงการขยายผลของมูลนิธิแม่ฟ้าหลวง พระบรมราชูปถัมภ์</span></div></>)}
                            {data.rights3 && (<><div><span>สิทธิ์ที่ 3 </span><span>เป็นเยาวชนที่กำลังศึกษาระดับชั้นมัธยมศึกษาปีที่ 6 ในโรงเรียนบ้านห้วยไร่สามัคคี</span></div></>)}
                            {data.rights4 && (<><div><span>สิทธิ์ที่ 4 </span><span>เป็นบุตรพนักงานมูลนิธิแม่ฟ้าหลวงฯ (เป็นพนักงานปัจจุบัน)</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>รายละเอียดบุคคลที่ทำงานในมูลนิธิแม่ฟ้าหลวงฯ</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>บิดา รหัสพนักงาน: {data.rights_father_no} ตำแหน่งงาน: {data.rights_father_job_title}</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>ส่วนงาน/แผนก: {data.rights_father_department} จำนวนปีที่ทำงานในมูลนิธิฯ: {data.rights_father_years}</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>มารดา รหัสพนักงาน: {data.rights_mother_no} ตำแหน่งงาน: {data.rights_mother_job_title}</span></div>
                                <div style={{ marginLeft: '2em', marginBottom: '0.1em' }}><span>ส่วนงาน/แผนก: {data.rights_mother_department} จำนวนปีที่ทำงานในมูลนิธิฯ: {data.rights_mother_job_title}</span></div></>)}
                        </Card>
                    </Col>
                </Row>
                    <br />
                </div>
            })

            await this.promisedSetState({ loading: false })
        }
    }

    generateRandomString = (amount) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
        for (let i = 0; i < amount; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };

    handlePrint = () => {
        // Open a new window with full screen size (height and width of the current browser window)
        const printWindow = window.open('', '', `height=${window.innerHeight},width=${window.innerWidth}`);

        const content = document.getElementById('printable').innerHTML; // Get content to print by ID

        // Define the print styles and include the font-face rule
        const printStyles = `
            @font-face {
                font-family: 'TH_Sarabun';
                src: url(${TH_Sarabun_PSK});
            }
            body {
                font-family: 'TH_Sarabun', sans-serif;
                font-size: 14pt;
                line-height: 1.2;
            }
            /* Additional styles for printing */
        `;

        const randomString = this.generateRandomString(8); // Generate a random 8-character string

        // Write the content into the new window
        printWindow.document.write(`<html><head><title>${randomString}</title>`);
        printWindow.document.write(`<style>${printStyles}</style>`);  // Add styles to the print window
        printWindow.document.write('</head><body>');
        printWindow.document.write(content); // Add the content to print
        printWindow.document.write('</body></html>');

        // Close the document and trigger the print dialog after a delay
        printWindow.document.close();

        // Add delay for the content to load properly
        setTimeout(() => {
            printWindow.print();
        }, 500); // Adjust time if necessary
    };

    handleExportToDocx = () => {
        const content = document.getElementById('printable').innerHTML; // Get content to export by ID

        // Define the print styles, this can also be customized if needed
        const printStyles = `
            @font-face {
                font-family: 'TH_Sarabun';
                src: url(${TH_Sarabun_PSK});
            }
            body {
                font-family: 'TH_Sarabun', sans-serif;
                font-size: 14pt;
            }
            /* Additional styles for DOCX export */
        `;

        const randomString = this.generateRandomString(8); // Generate a random 8-character string for filename

        // Create a new document with the content and styles
        const docContent = `
            <html>
                <head>
                    <title>${randomString}</title>
                    <style>${printStyles}</style>
                </head>
                <body>
                    ${content}
                </body>
            </html>
        `;

        // Convert HTML to DOCX
        const converted = htmlDocx.asBlob(docContent);

        // Create a link element to trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(converted);
        link.download = `${randomString}.docx`; // Set the filename
        link.click(); // Trigger the download
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.header}
                {this.state.content}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(DetailPage);
